import { Injectable } from '@angular/core';
import { IDeviceModel } from '@nx-fe/services';
// import { hd } from 'src/all';

// type IDeviceModel = hd.IDeviceModel;

@Injectable({
  providedIn: 'root',
})
export class DeviceIconService {
  /**
   * This change is specifically for Windows Modern Desktop.
   * Since we are only have device family and kind.
   * The difference between Legacy Windows and modern Windows are:
   *                  Device Kind          | Device Family
   * Legacy Desktop | WindowsDesktopLegacy | WindowsDesktop
   * Modern Desktop | WindowsDesktop       | WindowsPhone
   * Therefore we need to matche those two here to determine the actual platform
   * TODO:
   *      Use one parameter to determine the platform instead of two.
   */
  public getDeviceIconClass = (deviceModel: IDeviceModel): string => {
    let deviceFamily = deviceModel ? deviceModel.family : '';
    const deviceKind = deviceModel ? deviceModel.kind : '';

    if (deviceKind != null && deviceKind === 'WindowsDesktop' && deviceFamily === 'WindowsPhone') {
      deviceFamily = 'WindowsDesktop';
    }
    if (deviceKind === 'Mac') {
      deviceFamily = 'AppleDesktop';
    }
    let deviceIconClass = this.getDeviceIconClassName(deviceFamily);
    if (!this.isDeviceInfoAvailable(deviceModel)) {
      deviceIconClass += ' ' + 'color-gray-lighter';
    }

    return deviceIconClass;
  };

  /**
   * This change is specifically for Windows Modern Desktop.
   * Since we are only have device family and kind.
   * The difference between Legacy Windows and modern Windows are:
   *                  Device Kind          | Device Family
   * Legacy Desktop | WindowsDesktopLegacy | WindowsDesktop
   * Modern Desktop | WindowsDesktop       | WindowsPhone
   * Therefore we need to matche those two here to determine the actual platform
   * TODO:
   *      Use one parameter to determine the platform instead of two.
   */
  // public getDeviceScreenIconClass = (deviceFamily: string, deviceKind: string): string => {
  public getDeviceScreenIconClass = (deviceModel: IDeviceModel): string => {
    let deviceFamily = deviceModel ? deviceModel.family : '';
    const deviceKind = deviceModel ? deviceModel.kind : '';

    if (deviceKind != null && deviceKind === 'WindowsDesktop' && deviceFamily === 'WindowsPhone') {
      deviceFamily = 'WindowsDesktop';
    }
    if (deviceKind === 'Mac') {
      deviceFamily = 'AppleDesktop';
    }
    let deviceScreenIconClass = this.getDeviceScreenIconClassName(deviceFamily);

    if (!this.isDeviceInfoAvailable(deviceModel)) {
      deviceScreenIconClass += ' ' + 'color-gray-lighter';
    } else if (deviceScreenIconClass !== '') {
      deviceScreenIconClass = this.getOnlineOfflineSuffix(deviceScreenIconClass, deviceModel);
    }

    return deviceScreenIconClass;
  };

  public isDeviceInfoAvailable = (deviceModel: IDeviceModel): boolean =>
    !!deviceModel && !!deviceModel.deviceName && deviceModel.deviceName.length > 0;

  private getOnlineOfflineSuffix = (deviceScreenIconClass: string, deviceModel: IDeviceModel): string => {
    if (deviceModel && deviceModel.isAgentOnline) {
      deviceScreenIconClass += ' online';
    } else {
      deviceScreenIconClass += ' offline';
    }

    return deviceScreenIconClass;
  };

  /**
   * Returns the _single_ css class representing the icon for the given device
   *
   * @param deviceFamily The device family (or platform)
   */
  private getDeviceScreenIconClassName = (deviceFamily: string): string => {
    const deviceScreenIconClass = this.generateDeviceIconString(this.getDeviceCssClass(deviceFamily, 'screen'));
    return deviceScreenIconClass;
  };

  /**
   * Returns the _single_ css class representing the icon for the given device
   *
   * @param deviceFamily The device family (or platform)
   */
  private getDeviceIconClassName = (deviceFamily: string): string =>
    this.generateDeviceIconString(this.getDeviceCssClass(deviceFamily, ''));

  /**
   * Returns the _single_ css class representing the icon for the given device
   *
   * @param icon The device css class string
   */
  public generateDeviceIconString = (icon: string): string => {
    let result = '';
    if (icon !== '') {
      result = 'hd-icon middle icon-xxxlg overlap ' + icon;
    }
    return result;
  };

  /**
   * Returns the _single_ css class representing the icon for the given device
   *
   * @param deviceFamily The device family (or platform)
   */
  public getDeviceCssClass = (deviceFamily: string, suffix: string): string => {
    let deviceIconClass = '';
    if (suffix === '') {
      deviceIconClass = 'hd-icon-question';
    }

    switch (deviceFamily) {
      case 'Android':
      case 'AndroidPlus':
      case 'WindowsPhone':
      case 'Apple':
        deviceIconClass = 'hd-icon-phone' + suffix;
        break;
      case 'AppleDesktop':
        deviceIconClass = 'hd-icon-desktop' + suffix;
        break;
      case 'WindowsRuntime':
      case 'WindowsDesktop':
        deviceIconClass = 'hd-icon-desktop' + suffix;
        break;
      case 'WindowsCE':
        deviceIconClass = 'hd-icon-' + suffix + (suffix !== '' ? '-' : '') + 'DeviceWindowsCE';
        break;
      case 'Scanner':
      case 'Printer':
        deviceIconClass = 'hd-icon-printer' + suffix;
        break;
      case 'Linux':
        deviceIconClass = 'hd-icon-DeviceLinux' + suffix;
        break;
      // Reusing Linux graphics temporarily.
      case 'Tizen':
        deviceIconClass = 'hd-icon-DeviceLinux' + suffix;
        break;
      case 'Unmanaged':
        deviceIconClass = 'hd-icon-alldevice-alt' + suffix;
        break;
    }

    return deviceIconClass;
  };
}
